import { render } from "./Configurator.vue?vue&type=template&id=2ecda9ef&scoped=true"
import script from "./Configurator.vue?vue&type=script&lang=js"
export * from "./Configurator.vue?vue&type=script&lang=js"

import "./Configurator.vue?vue&type=style&index=0&id=2ecda9ef&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecda9ef"]])

export default __exports__